import { InlineEdit } from '@lmc/ui-kit'
import { Form } from 'antd'
import { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'
import { commonPatterns } from '../../../../../../utils/enhancedTestIds'

type InlineNameEditProps = {
  value: string
  label: string
  isInlineEditing?: boolean
  handleUpdateDevice?: (name: string) => void
  setIsInlinEditing?: Dispatch<SetStateAction<boolean | undefined>>
  disabled?: boolean
  error?: string | undefined
  isLoading?: boolean
  onReset?: () => void
  testId?: string
}

const mapError = (error?: string) => {
  if (error === 'Field [name] must not exceed 20 characters') {
    return 'Name must not exceed 20 characters'
  }
  return error
}

const InlineNameEdit: FC<InlineNameEditProps> = ({
  value,
  label,
  handleUpdateDevice,
  setIsInlinEditing,
  disabled,
  error,
  isLoading,
  onReset,
  testId
}) => (
  <FormItemStyled
    label={label}
    validateStatus={error ? 'error' : undefined}
    help={mapError(error) || undefined}
    style={{ minWidth: 200 }}
    data-testid={testId}
  >
    <InlineEdit
      disabled={disabled}
      value={value}
      onChange={(name) => handleUpdateDevice?.(name)}
      isEditing={isLoading || !!error}
      onEditStateChange={(editState) => {
        setIsInlinEditing?.(editState)
      }}
      onCancel={() => {
        if (error) {
          onReset?.()
        }
      }}
      data-testid={
        testId ? commonPatterns.input(testId, 'inline-edit') : undefined
      }
    />
  </FormItemStyled>
)

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-label {
    min-width: 120px;
    text-align: start !important;
  }

  .ant-form-item-label > label {
    color: ${({ theme }) => theme.color.neutral.color4};
  }

  margin-top: 5px;
  margin-bottom: 5px;

  .ant-form-item-control-input-content > div > div {
    font-weight: 500;
  }
`

export default InlineNameEdit
